import { message } from "antd";
import AButton from "core/presentation/components/Button";
import ATitle from "core/presentation/components/Title";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "core/presentation/store/hooks";
import Loader from "core/presentation/components/Loader";
import { RootState } from "core/presentation/store";
import { useSelector } from "react-redux";
import { userThunks } from "user/presentation/store/userSlice";
import DeleteConfirmationModal from "core/presentation/components/DeleteCofirmationBox";
import PaginationTable from "core/presentation/components/PaginationTable";

const ShipperList = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [shipperList, setShipperList] = useState<any>([]);
  const { userProfile } = useAppSelector((state) => state.user);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<any>();
  const { shippers, isLoading, shippersCount, error } = useSelector((state: RootState) => state.user);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const haveAction = userProfile?.user?.permissions.includes("shipper:delete") || userProfile?.user?.permissions.includes("shipper:update") || userProfile?.user?.permissions.includes("shipper:detail");

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Contact No.", dataIndex: "contact", key: "contact" },
    { title: "Status", dataIndex: "accountStatus", key: "accountStatus" },
    ...(haveAction
      ? [
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
          },
        ]
      : []),
  ];

  useEffect(() => {
    if (shippers) {
      setShipperList(shippers);
    }
  }, [shippers]);

  useEffect(() => {
    getAllShippers(currentPage);
  }, [dispatch]);

  const getAllShippers = (page: number, input?: string, filterValue?: string) => {
    dispatch(
      userThunks.getAllShipperThunk({
        page: page,
        input: input ?? "",
        filter: filterValue ?? "",
      }),
    );
  };

  const handleDelete = async (id: any) => {
    try {
      await dispatch(userThunks.deleteShipperThunk(id));
      message.success("Shipper deleted successfully");
      setDeleteModalVisible(false);
    } catch (error) {
      message.error("Shipper delete failed");
    } finally {
      getAllShippers(currentPage);
    }
  };
  const showDeleteConfirm = (id: any) => {
    setSelectedUserId(id);
    setDeleteModalVisible(true);
  };
  const handleCreateDriver = () => {
    navigate("/shipper/create");
  };

  const shipperListDataSource = shippers?.shippers?.map((data: any) => ({
    key: data?.userId?.userId,
    name: (data?.userId?.firstName && data?.userId?.lastName && `${data?.userId?.firstName} ${data?.userId?.lastName}`) || `${data?.userId?.company?.companyName} `,
    contact: data?.userId?.contactNumber || data?.userId?.company?.companyContactNumber,
    accountStatus: data?.userId?.accountStatus,

    action: (
      <>
        {/* {userProfile?.user?.permissions.includes("shipper:delete") && (
              <AButton
                style={{
                  marginTop: "0",
                  padding: "5px",
                  color: "#475467",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                type="text"
                onClick={() => {
                  showDeleteConfirm(data?.userId);
                }}
              >
                Delete
              </AButton>
            )}
            {userProfile?.user?.permissions.includes("shipper:update") && (
              <AButton
                style={{
                  marginTop: "0",
                  padding: "5px",
                  color: "#475467",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                type="text"
                onClick={() => navigate(`/shipper/edit/${data?.userId}`)}
              >
                Edit
              </AButton>
            )} */}
        {userProfile?.user?.permissions.includes("shipper:detail") && (
          <AButton
            style={{
              marginTop: "0",
              padding: "5px",
              color: "#F26533",
              fontSize: "14px",
              fontWeight: "600",
            }}
            type="text"
            onClick={() => navigate(`/shipper/details/${data?.userId}`)}
          >
            View
          </AButton>
        )}
      </>
    ),
    date: data.updated_at,
  }));
  return (
    <div>
      {loading && <Loader />}
      {!loading && (
        <>
          <div>
            <ATitle content={"Shippers Details"} fontSize={14} fontWeight={600} />
          </div>

          <div style={{ marginTop: "10px" }}>
            {/* <SearchFilterSection /> */}

            <PaginationTable dataSource={shipperListDataSource} columns={columns} tableTitle="Shipper List" loading={isLoading || !shipperListDataSource} totalData={shippersCount} currentPage={currentPage} setCurrentPage={setCurrentPage} handleChange={getAllShippers} />
          </div>
        </>
      )}
      <DeleteConfirmationModal visible={deleteModalVisible} onConfirm={() => handleDelete(selectedUserId)} onCancel={() => setDeleteModalVisible(false)} />
    </div>
  );
};

export default ShipperList;
